window.addEventListener("DOMContentLoaded", function () {
  var questions = document.querySelectorAll(".question-block");

  var isLinkOrChildOfLink = function (target) {
    while (target) {
      if (target.tagName === "A") return true;
      target = target.parentElement;
    }
    return false;
  };

  var _loop = function _loop(i) {
    questions[i].addEventListener("click", function (event) {
      // Check if the clicked element or any of its parent is a link
      if (isLinkOrChildOfLink(event.target)) {
        return; // Exit the function if it's a link
      }

      event.preventDefault();
      var container = document.getElementById(questions[i].dataset.container);
      var headline = questions[i].getElementsByClassName("question")[0];
      if (!container.classList.contains("active")) {
        container.classList.add("active");
        headline.classList.add("active");
        container.style.height = "auto";
        var height = container.clientHeight + "px";
        container.style.height = "0px";
        setTimeout(function () {
          container.style.height = height;
        }, 0);
      } else {
        container.style.height = "0px";
        container.addEventListener(
          "transitionend",
          function () {
            container.classList.remove("active");
            headline.classList.remove("active");
          },
          {
            once: true,
          }
        );
      }
    });
  };

  for (var i = 0; i < questions.length; i++) {
    _loop(i);
  }
});

// This obfuscates phone number. CSS is in mtw.scss
(function () {
  const elements = document.getElementsByClassName("protectedNumber");
  console.log("elements", elements);
  for (var i = 0; i < elements.length; i++) {
    this.attr();
  }
})();

//   const body = document.querySelector("body");
//   if (body.classList.contains("home")) {
//     // const video = document.getElementById("homevideo");
//     // const videoOverlay = document.getElementById("de-video-overlay");
//     // const textCenter = document.getElementById("de-video-content");
//     // setInterval(() => {
//     //   const videoHeight = video.clientHeight;
//     //   const videoOverlayHeight = videoOverlay.clientHeight;
//     //   if (videoHeight !== videoOverlayHeight) {
//     //     videoOverlay.style.height = videoHeight + "px";
//     //     textCenter.style.height = videoHeight + "px";
//     //   }
//     // }, 0);
//   }

//   //   setTimeout(function(){
//   //     console.log(video.clientHeight);
//   // }, 500);

//   // setTimeout(function(){
//   //   console.log(videoOverlay.clientHeight);
//   // }, 0);
// });
